module.exports = __webpack_public_path__ + "static/media/joao.261a1103.svg";